export default "__VITE_ASSET__DHTys_y1__"